import { ChannelCategoryListComponent } from './channel-category/channel-category-list/channel-category-list.component';
import { ChannelModelerComponent } from './channel-modeler/channel-modeler.component';
import { RuleNarrativePipe } from './channel-rule/rule-narrative.pipe';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChannelRuleComponent } from './channel-rule/channel-rule.component';
import { ChannelRuleTesterComponent } from './channel-rule/channel-rule-tester/channel-rule-tester.component';
import { ChannelGroupListComponent } from './channel-group/channel-group-list/channel-group-list.component';
import { ChannelGroupEditComponent } from './channel-group/channel-group-edit/channel-group-edit.component';
import { ChannelEditComponent } from './channel-edit/channel-edit.component';
import { CaseModule } from '../case/case.module';
import { TaskModule } from '../task/task.module';
import { QueryBuilderModule } from '../shared/query-builder/query-builder.module';
import { MessageModule } from '../message/message.module';
import { ChannelDetailComponent } from './channel-detail/channel-detail.component';
import { ChannelCategoryEditComponent } from './channel-category/channel-category-edit/channel-category-edit.component';
import { ChannelStatusComponent } from './channel-status/channel-status.component';
import { PatientEditModule } from '../shared/patient-edit/patient-edit.module';
import { PDFViewerModule } from '@progress/kendo-angular-pdfviewer';
import { ChannelAuditModule } from './channel-audit/channel-audit.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CaseModule,
    TaskModule,
    QueryBuilderModule,
    MessageModule,
    PatientEditModule,
    PDFViewerModule,
    ChannelAuditModule
  ],
  declarations: [
    ChannelRuleComponent,
    ChannelRuleTesterComponent,
    ChannelModelerComponent,
    ChannelGroupListComponent,
    ChannelGroupEditComponent,
    ChannelEditComponent,
    ChannelDetailComponent,
    ChannelCategoryListComponent,
    ChannelCategoryEditComponent,
    RuleNarrativePipe,
    ChannelStatusComponent
  ],
  exports: [
    ChannelRuleComponent,
    ChannelRuleTesterComponent,
    ChannelModelerComponent,
    ChannelGroupListComponent,
    ChannelGroupEditComponent,
    ChannelEditComponent,
    ChannelDetailComponent,
    ChannelCategoryListComponent,
    ChannelCategoryEditComponent,
    ChannelStatusComponent,
    RuleNarrativePipe
  ]
})
export class ChannelModule { }
